import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { StockChart, Chart } from 'angular-highcharts';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Meta, Title } from '@angular/platform-browser';
import { interval } from 'rxjs';


@Component({
  selector: 'app-temperature-instant',
  templateUrl: './temperature-instant.component.html',
  styleUrls: ['./temperature-instant.component.css']
})
export class TemperatureInstantComponent implements OnInit {
  
  temperatureInstant: Chart;

  constructor(
    private http: HttpClient,
    private meta: Meta,
    private titleService: Title) {
    this.meta.updateTag({ name: 'title', content: 'Artproject - temperature instant' });
    this.meta.updateTag({ name: 'description', content: 'Artproject - temperature instant' });
    this.meta.updateTag({ name: 'keywords', content: 'Artproject - temperature instant' });
    this.titleService.setTitle('Artproject');
  }

  ngOnInit() {
    this.listValueTemperature();
    interval(1000 * environment.timeToRefresh).subscribe(x => {
      this.refrash();
    });
  }


  listValueTemperature() {
    this.http.get(`${environment.apiUrl}/temperatureInstant.php`)
      .subscribe((res: any) => {
        console.log('json temperature', res);
        this.temperatureInstant = new Chart({
          chart: {
            type: 'gauge',
            plotBackgroundColor: null,
            plotBackgroundImage: null,
            plotBorderWidth: 0,
            plotShadow: false
          },
          pane: {
            startAngle: -150,
            endAngle: 150,
            background: [{
              backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, '#FFF'],
                  [1, '#333']
                ]
              },
              borderWidth: 0,
              outerRadius: '109%'
            }, {
              backgroundColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, '#333'],
                  [1, '#FFF']
                ]
              },
              borderWidth: 1,
              outerRadius: '107%'
            }, {
              // default background
            }, {
              backgroundColor: '#DDD',
              borderWidth: 0,
              outerRadius: '105%',
              innerRadius: '103%'
            }]
          },

          // the value axis
          yAxis: {
            min: -50,
            max: 76,

            minorTickInterval: 'auto',
            minorTickWidth: 1,
            minorTickLength: 10,
            minorTickPosition: 'inside',
            minorTickColor: '#666',

            tickPixelInterval: 30,
            tickWidth: 2,
            tickPosition: 'inside',
            tickLength: 10,
            tickColor: '#666',
            labels: {
              step: 2,
              rotation: 'auto'
            },
            title: {
              text: 'Temp.'
            },
            plotBands: [{
              from: -50,
              to: -5,
              color: '#DF5353' // green
            }, {
              from: -5,
              to: 15,
              color: '#DDDF0D' // green
            }, {
              from: 15,
              to: 35,
              color: '#55BF3B' // yellow
            }, {
              from: 35,
              to: 75,
              color: '#DF5353' // red
            }]
          },
          rangeSelector: {
            selected: 1
          },
          title: {
            text: 'Instant Temperature'
          },
          time: {
            useUTC: false,
            timezoneOffset: 3600,
            timezone: 'Europe/Rome'
          },
          series: [{
            name: 'Temp.',
            data: res,
            tooltip: {
              valueSuffix: ' °'
            }
          }]
        } as any);
      });

  }

  // add point to chart serie
  refrash() {
    //this.listValueTemperature()
    this.http.get(`${environment.apiUrl}/temperatureInstant.php`)
       .subscribe((res: any) => {
         console.log('temperature update', res);
         var point = this.temperatureInstant.removePoint(0)
         var point = this.temperatureInstant.addPoint(res)
         //point.update({series: [{data: res}]});
    });
  }


}
